import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import { Tabs, Tab } from 'components/common/tabs/tabs';
import Inputs from 'components/inputs/inputs';
import useAsyncEffect from 'use-async-effect';
import BackofficeReportsHelper from 'components/navigation/backofficeReports/backofficeReportsHelper';
import SiteContext from 'components/shared/siteContext/siteContext';
import './employeeAdd.css';
import Stepper from 'components/common/stepper/stepper';
import employeeService from 'services/employeeService';

const styles = {
  topNav: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '0.5rem',
  },
  backNextButtons: {
    width: '1rem',
    paddingLeft: '1rem',
    paddingRight: '2rem',
  },
};

export default function EmployeeAdd(props) {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [employmentType, setEmploymentType] = useState('r');
  const [employeeNumber, setEmployeeNumber] = useState('');
  const [gender, setGender] = useState('m');
  const [geoState, setGeoState] = useState('');
  const [step, setStep] = useState(1);
  const [basePay, setBasePay] = useState('');
  const [maritalStatus, setMaritalStatus] = useState('single');
  const [hiredDate, setHiredDate] = useState();
  const [leftDate, setLeftDate] = useState();
  const [cardNumber, setCardNumber] = useState('');
  const [ssn, setSSN] = useState('');
  const [phone, setPhone] = useState('');
  const [city, setCity] = useState('');
  const [address1, setAddress1] = useState('');
  const [address2, setAddress2] = useState('');
  const [isLoaded, setIsLoaded] = useState(false);
  const [hierarchyId, setHierarchyId] = useState();
  const [email, setEmail] = useState('');

  useAsyncEffect(async () => {
    setHierarchyId(await BackofficeReportsHelper.getSiteContextHierarchy());
    setIsLoaded(true);
  }, [hierarchyId]);

  const handleSelectSite = async (id) => {
    await BackofficeReportsHelper.setSiteContextHierarchy(id);
    setHierarchyId(id);
  };

  const handleSubmit = async () => {
    employeeService.addEmployee({
      firstName,
      lastName,
      employmentType,
      employeeNumber,
      gender,
      ssn,
      phone,
      state: geoState,
      city,
      address1,
      address2,
      maritalStatus,
      basePay,
      cardNumber,
      hiredDate,
      leftDate,
      hierarchyId,
    });
    props.history.push('/EmployeeList/1');
  };

  const renderCurrentStep = (stepNumber) => {
    switch (stepNumber) {
      case 1:
        return (
          <div className='add-employee'>
            <SiteContext.Button loaded={isLoaded} hierarchyId={hierarchyId} onSelectSite={handleSelectSite} />

            <Form.Group>
              <Inputs.Text placeholder='First Name' value={firstName} onValueChange={setFirstName} />
            </Form.Group>
            <Form.Group>
              <Inputs.Text placeholder='Last Name' value={lastName} onValueChange={setLastName} />
            </Form.Group>
            <Form.Group>
              <Form.Label>Employment Type:</Form.Label>
              <Tabs onSelect={(key) => setEmploymentType(key)} selection={employmentType}>
                <Tab value='r' title='Regular'></Tab>
                <Tab value='m' title='Manager'></Tab>
              </Tabs>
            </Form.Group>
            <Form.Group>
              <Form.Label>Gender:</Form.Label>
              <Tabs onSelect={(key) => setGender(key)} selection={gender}>
                <Tab value='m' title='Male'></Tab>
                <Tab value='f' title='Female'></Tab>
              </Tabs>
            </Form.Group>
            <Form.Group>
              <Inputs.Text placeholder='SSN' value={ssn} onValueChange={setSSN} />
            </Form.Group>
            <Form.Group>
              <Inputs.Text placeholder='Phone' value={phone} onValueChange={setPhone} />
            </Form.Group>
            <Form.Group>
              <StateSelector value={geoState} onChange={setGeoState} />
            </Form.Group>
            <Form.Group>
              <Inputs.Text placeholder='City' value={city} onValueChange={setCity} />
            </Form.Group>
            <Form.Group>
              <Inputs.Text placeholder='Address 1' value={address1} onValueChange={setAddress1} />
            </Form.Group>
            <Form.Group>
              <Inputs.Text placeholder='Address 2' value={address2} onValueChange={setAddress2} />
            </Form.Group>
          </div>
        );
      case 2:
        return (
          <>
            <Form.Group>
              <Inputs.Email placeholder='Email' value={email} onValueChange={setEmail} />
            </Form.Group>
            <Form.Group>
              <Inputs.Integer placeholder='Employee Number' value={employeeNumber} onValueChange={setEmployeeNumber} />
            </Form.Group>
            <Form.Group>
              <Inputs.Integer placeholder='Base Pay' value={basePay} onValueChange={setBasePay} />
            </Form.Group>
            <Form.Group>
              <Form.Label>Marital Status:</Form.Label>
              <Tabs onSelect={(key) => setMaritalStatus(key)} selection={maritalStatus}>
                <Tab value='single' title='Single'></Tab>
                <Tab value='married' title='Married'></Tab>
              </Tabs>
            </Form.Group>
            <Form.Group>
              <Inputs.Date value={hiredDate} onChange={setHiredDate} placeholder='Select Date Hired' />
            </Form.Group>
            <Form.Group>
              <Inputs.Date value={leftDate} onChange={setLeftDate} placeholder='Select Date Left' />
            </Form.Group>
            <Form.Group>
              <Inputs.Integer placeholder='Card Number' value={cardNumber} onValueChange={setCardNumber} />
            </Form.Group>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <div style={styles.topNav} className='add-employee-header'>
        <Inputs.Button
          variant='app'
          onClick={() => {
            if (step === 1) {
              props.history.push('/EmployeeList');
            }
            else {
              setStep(step - 1);
            }
          }}
          style={styles.backNextButtons}
          iconClass='icons8-left'
        />

        <Stepper onStepChange={setStep} step={step}>
          <Stepper.Step title='Step 1' />
          <Stepper.Step title='Step 2' />
        </Stepper>

        <Inputs.Button
          variant='app'
          onClick={() => {
            if (step === 2) {
              handleSubmit();
            }
            else {
              setStep(step + 1);
            }
          }}
          style={styles.backNextButtons}
          iconClass='icons8-right'
        />
      </div>
      {renderCurrentStep(step)}
    </>
  );
}

function StateSelector(props) {
  return (
    <Inputs.Select value={props.value} onValueChange={props.onChange} placeholder='Select State'>
      <option value='AL'>Alabama</option>
      <option value='AK'>Alaska</option>
      <option value='AZ'>Arizona</option>
      <option value='AR'>Arkansas</option>
      <option value='CA'>California</option>
      <option value='CO'>Colorado</option>
      <option value='CT'>Connecticut</option>
      <option value='DE'>Delaware</option>
      <option value='DC'>District Of Columbia</option>
      <option value='FL'>Florida</option>
      <option value='GA'>Georgia</option>
      <option value='HI'>Hawaii</option>
      <option value='ID'>Idaho</option>
      <option value='IL'>Illinois</option>
      <option value='IN'>Indiana</option>
      <option value='IA'>Iowa</option>
      <option value='KS'>Kansas</option>
      <option value='KY'>Kentucky</option>
      <option value='LA'>Louisiana</option>
      <option value='ME'>Maine</option>
      <option value='MD'>Maryland</option>
      <option value='MA'>Massachusetts</option>
      <option value='MI'>Michigan</option>
      <option value='MN'>Minnesota</option>
      <option value='MS'>Mississippi</option>
      <option value='MO'>Missouri</option>
      <option value='MT'>Montana</option>
      <option value='NE'>Nebraska</option>
      <option value='NV'>Nevada</option>
      <option value='NH'>New Hampshire</option>
      <option value='NJ'>New Jersey</option>
      <option value='NM'>New Mexico</option>
      <option value='NY'>New York</option>
      <option value='NC'>North Carolina</option>
      <option value='ND'>North Dakota</option>
      <option value='OH'>Ohio</option>
      <option value='OK'>Oklahoma</option>
      <option value='OR'>Oregon</option>
      <option value='PA'>Pennsylvania</option>
      <option value='RI'>Rhode Island</option>
      <option value='SC'>South Carolina</option>
      <option value='SD'>South Dakota</option>
      <option value='TN'>Tennessee</option>
      <option value='TX'>Texas</option>
      <option value='UT'>Utah</option>
      <option value='VT'>Vermont</option>
      <option value='VA'>Virginia</option>
      <option value='WA'>Washington</option>
      <option value='WV'>West Virginia</option>
      <option value='WI'>Wisconsin</option>
      <option value='WY'>Wyoming</option>
    </Inputs.Select>
  );
}